import React, { Component, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  FormGroup,
  Label,
  Input,
  CustomInput,
  Button,
  TabContent,
  TabPane,
  Spinner
} from 'reactstrap';

// import useGet from '../../../helpers/hooks/useGet';
import Announcements from '../Baythak/CreateAnnouncement/components/Announcements';
import KisanPosts from '../Baythak/CreateAnnouncement/components/KisanPosts';
import qs from 'qs';
import useGetAuthed from '../../helpers/hooks/useGetAuthed';
import LoanList from './Loan-list';
import LoanDashboard from './LoanDashboard/indexx'
import AppStatusAndAnalysis from './LoanDashboard/AppStatusAndAnalysis';

function Loan() {

  const [data, error, loading, call] = useGetAuthed("dashboard", true, 'loan')

  console.log(data)

  const history = useHistory();
  const [activeTab, setActiveTab] = useState(
    qs.parse(history.location.search, { ignoreQueryPrefix: true }).tab || '1'
  );
  return (
    <React.Fragment>
      <Container fluid>
        <div className='page-content'>
          {/* <div className='align-items-end d-flex justify-content-between mb-3'>
            <h4>Loan</h4>
          </div> */}
        {/* <Card> */}

            {/* <LoanList loan={data}></LoanList> */}
            <LoanDashboard/>
        {/* </Card> */}
        </div>
      </Container>
    </React.Fragment>
  )
}

export default Loan